
import { defineComponent, reactive } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// validations
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        }  
    },
    emits: ['cancel', 'submit'],
    setup(props, { emit }) {
        const state = reactive({
            packCode: null as string | null
        })

        const state_form$ = useVuelidate({
            packCode: { required }
        }, state)

        const emitCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        const emitSubmit = () => {
            if (props.loading) return
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submit', state.packCode)
        }

        return {
            state,
            state_form$,
            emitCancel,
            emitSubmit,
        }
    },
})
